module.exports = __webpack_public_path__ + "static/img/3-2.aa62433.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/3-2.png
// module id = 266
// module chunks = 0